import styled from 'styled-components';
import { Box } from '../../../CommonComponents/OPL/Box/Box';

export const StyledEntity = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  borderBottom: `1px solid ${theme.colors.neutral['200']}`,
  height: 72,
  padding: '0 16px',
  overflow: 'hidden',
}));

export const ClickableEntityStyle = styled(StyledEntity)(({ theme }) => ({
  cursor: 'pointer',

  '&:hover, &[data-focus-visible-added]:focus': {
    background: theme.colors.neutral['50'],
  },
}));
